<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from './form/index';
import Adjustment from './form/adjustment';
import FundDetails from './form/fund_details';

export default {
  extends: TablePage,
  components: {
    Form,
    Adjustment,
    FundDetails,
  },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('red_packet_pool_list');
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      }
      if (val.code === 'adjustment') { // 调整
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };

        this.modalConfig.title = '调整';

        this.formName = 'Adjustment';
        this.openDrawer();
      }
      if (val.code === 'fund_details') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '资金明细';

        this.formName = 'FundDetails';
        this.openFull();
      }
    },
  },
};
</script>
